import { api, apiUrl } from "../../shared/services/service";
import {
  AdminKeysSecretsMailboxPayload,
  AdminKeysSecretsPageResponse,
  AdminKeysSecretsRotationStatusResponse,
} from "../models/admin-keys-secrets.models";
import axios from "axios";

export const getAdminKeysSecrets = async (): Promise<AdminKeysSecretsPageResponse> => {
  const response = await api.get(`${apiUrl}/admin/keys-secrets`);
  return response.data;
};

export const getAdminKeysSecretsStatus = async (): Promise<AdminKeysSecretsRotationStatusResponse> => {
  const response = await api.get(`${apiUrl}/admin/keys-secrets/status`);
  return response.data;
};

export const saveAdminKeysSecretsMailbox = async (
  payload: AdminKeysSecretsMailboxPayload,
): Promise<AdminKeysSecretsRotationStatusResponse> => {
  const response = await api.post(`${apiUrl}/admin/keys-secrets/mailbox`, payload);
  return response.data;
};

export const markAdminKeysSecretsRotationDone = async (): Promise<AdminKeysSecretsRotationStatusResponse> => {
  const response = await api.post(`${apiUrl}/admin/keys-secrets/rotation-done`, {});
  return response.data;
};

export const getAdminKeysSecretsErrorMessage = (error: unknown) => {
  if (axios.isAxiosError(error)) {
    const responseData = error.response?.data as { error?: string; message?: string } | string | undefined;

    if (typeof responseData === "string") {
      return responseData;
    }

    return responseData?.error ?? responseData?.message ?? error.message;
  }

  if (error instanceof Error) {
    return error.message;
  }

  return "Keys & Secrets request failed.";
};
